import { FsagFormattedPreset, ParamObject } from '~/@types/calculator';

export default function mapFinanceDataToRequest(
	product: string | undefined,
	parameters:
		| Array<{ __typename: 'FinancingProductParameter'; key: string; value: string } | null>
		| null
		| undefined,
) {
	const params: Array<ParamObject> = [];

	if (parameters && parameters.length > 0) {
		parameters.forEach((param) => {
			if (param && param.key && param.value) {
				params.push({
					'@ID': param?.key,
					'#text': param?.value,
				});
			}
		});
	}

	const formattedProduct: FsagFormattedPreset = {
		'@ID': product!,
		Parameter: params,
	};

	return formattedProduct;
}
